import { useEffect, useState } from "react";
import "./Toast.css";

let toastId = 0;

export function useToast() {
  const [toasts, setToasts] = useState([]);

  const addToast = (type, message, duration = 3000) => {
    const id = ++toastId;
    setToasts((prev) => [...prev, { id, type, message }]);
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, duration);
  };

  const removeToast = (id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  };

  return { toasts, addToast, removeToast };
}

export default function Toast({ toasts, removeToast }) {
  if (toasts.length === 0) return null;

  return (
    <div className="toast-container" aria-live="polite">
      {toasts.map((toast) => (
        <ToastItem key={toast.id} toast={toast} onDismiss={removeToast} />
      ))}
    </div>
  );
}

function ToastItem({ toast, onDismiss }) {
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setExiting(true), 2700);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={`toast toast--${toast.type}${exiting ? " toast--exit" : ""}`}
      role="alert"
      onClick={() => onDismiss(toast.id)}
    >
      <span className="toast__icon">
        {toast.type === "success" ? "✓" : toast.type === "error" ? "✕" : "i"}
      </span>
      <span className="toast__message">{toast.message}</span>
    </div>
  );
}
